import React from "react";
import { lineCabinetRegister } from "../../Auth/Config";
import ArrowIcon from "../../../assets/svg/icons/arrow-right-button.inline.svg";

const RealMoneyPrompt = () => {

  return (
    <div className="fs-real-money">
      <div className="text">
        <h2>สมัครสมาชิกเล่นด้วยเงินจริง</h2>
        <p className="details">ระบบจะนำคุณไปที่หน้าบัญชี Lnwasiaข้อมูลทุกอย่างของคุณจะถูกเก็บเป็นความลับ.</p>
      </div>
      <div className="btn-wrap">
        <a className="real-money-reg-gamepage button wallet-reg-button" href={lineCabinetRegister} target="_blank"
           rel="noopener noreferrer">
          <span>Lnwasia Wallet</span>
          <ArrowIcon/>
        </a>
      </div>
    </div>
  );
};

export default RealMoneyPrompt;

